import React from 'react';
import Header from '../Header';
import { Helmet } from 'react-helmet-async';
import Footer from './Footer';
import '../../css/LegalPages.css';

const PrivacyPolicy = () => {
    return (
        <>
            <Helmet>
                <title>Politique de confidentialité | CC Débarras 14</title>
                <meta name="description" content="Politique de confidentialité et traitement des données personnelles du site CC Débarras 14." />
                <link rel="canonical" href="https://ccdebarras14.fr/politique-confidentialite" />
                <meta property="og:title" content="Politique de confidentialité | CC Débarras 14" />
                <meta property="og:description" content="Politique de confidentialité et traitement des données personnelles du site CC Débarras 14." />
                <meta property="og:url" content="https://ccdebarras14.fr/politique-confidentialite" />
                <meta property="og:type" content="website" />
            </Helmet>

            <Header />
            <div className="legal-page">
                <div className="legal-content">
                    <h1>Politique de Confidentialité</h1>
                    
                    <section className="legal-section">
                        <h2>1. Introduction</h2>
                        <p>CC Débarras 14 (MADAME CARINE GAUTHERIE) s'engage à protéger la confidentialité de vos données personnelles. Cette politique explique comment nous collectons, utilisons et protégeons vos informations personnelles conformément au Règlement Général sur la Protection des Données (RGPD).</p>
                    </section>

                    <section className="legal-section">
                        <h2>2. Responsable du traitement</h2>
                        <p><strong>Raison sociale :</strong> MADAME CARINE GAUTHERIE</p>
                        <p><strong>Nom commercial :</strong> CC Débarras 14</p>
                        <p><strong>SIREN :</strong> 848 965 612</p>
                        <p><strong>Adresse :</strong> RUE DES GENETS 7598 LE BIEF DU MOULIN, 14800 SAINT-ARNOULT, France</p>
                        <p><strong>Téléphone :</strong> 07 67 56 72 54</p>
                        <p><strong>Email :</strong> <a href="mailto:ccdebarras14@gmail.com">ccdebarras14@gmail.com</a></p>
                    </section>

                    <section className="legal-section">
                        <h2>3. Données collectées</h2>
                        <p>Nous collectons les données suivantes :</p>
                        <ul>
                            <li><strong>Via le formulaire de contact :</strong> nom, prénom, téléphone, email (optionnel), type de service demandé, objet de la demande, description du projet</li>
                            <li><strong>Données de contact directes :</strong> informations transmises par téléphone ou email</li>
                            <li><strong>Données de navigation :</strong> adresse IP, type de navigateur, pages visitées</li>
                            <li><strong>Données de prestation :</strong> type de débarras, adresse du bien, informations sur les objets, photos avant/après</li>
                            <li><strong>Données commerciales :</strong> historique des prestations, préférences client</li>
                        </ul>
                    </section>

                    <section className="legal-section">
                        <h2>4. Finalités du traitement</h2>
                        <p>Vos données sont utilisées pour :</p>
                        <ul>
                            <li>Traiter vos demandes de devis via notre formulaire de contact</li>
                            <li>Vous recontacter suite à votre demande (téléphone ou email)</li>
                            <li>Planifier et réaliser les interventions de débarras</li>
                            <li>Gérer la vente d'objets récupérés sur nos plateformes (Leboncoin, Facebook Marketplace)</li>
                            <li>Améliorer notre site web et nos services</li>
                            <li>Respecter nos obligations légales et comptables</li>
                            <li>Gérer la relation client et le suivi des prestations</li>
                            <li>Constituer un portfolio de nos réalisations (avec votre accord)</li>
                        </ul>
                    </section>

                    <section className="legal-section">
                        <h2>5. Base légale du traitement</h2>
                        <p>Le traitement de vos données repose sur :</p>
                        <ul>
                            <li><strong>L'exécution d'un contrat :</strong> pour la réalisation de nos prestations de débarras</li>
                            <li><strong>L'intérêt légitime :</strong> pour traiter vos demandes de devis et améliorer nos services</li>
                            <li><strong>Le consentement :</strong> pour l'utilisation de photos à des fins promotionnelles</li>
                            <li><strong>L'obligation légale :</strong> pour la conservation des données comptables et fiscales</li>
                        </ul>
                    </section>

                    <section className="legal-section">
                        <h2>6. Service d'envoi d'emails (EmailJS)</h2>
                        <p>Notre formulaire de contact utilise le service EmailJS pour l'envoi d'emails. Dans ce cadre :</p>
                        <ul>
                            <li><strong>Données transmises :</strong> nom, téléphone, email, type de service, objet et description de votre demande</li>
                            <li><strong>Finalité :</strong> transmission sécurisée de votre demande de devis</li>
                            <li><strong>Durée de transit :</strong> les données ne sont stockées que le temps nécessaire à l'envoi</li>
                            <li><strong>Sécurité :</strong> EmailJS utilise des protocoles de chiffrement pour protéger vos données</li>
                            <li><strong>Localisation :</strong> EmailJS est conforme au RGPD et respecte les standards européens</li>
                        </ul>
                        <p>Vos données ne sont pas stockées de façon permanente par EmailJS et ne sont utilisées à aucune autre fin.</p>
                    </section>

                    <section className="legal-section">
                        <h2>7. Durée de conservation</h2>
                        <p>Vos données sont conservées selon les durées suivantes :</p>
                        <ul>
                            <li><strong>Demandes de devis :</strong> 3 ans à compter de la demande (même sans suite donnée)</li>
                            <li><strong>Données clients actifs :</strong> pendant toute la durée de la relation commerciale</li>
                            <li><strong>Données clients inactifs :</strong> 3 ans après la dernière prestation</li>
                            <li><strong>Données de prospection :</strong> 3 ans à compter du dernier contact</li>
                            <li><strong>Données comptables et factures :</strong> 10 ans conformément aux obligations légales</li>
                            <li><strong>Données de navigation (cookies) :</strong> 13 mois maximum</li>
                            <li><strong>Photos et témoignages :</strong> jusqu'à retrait du consentement</li>
                        </ul>
                    </section>

                    <section className="legal-section">
                        <h2>8. Partage des données</h2>
                        <p>Vos données peuvent être partagées avec :</p>
                        <ul>
                            <li><strong>Service d'emails :</strong> EmailJS pour l'envoi de vos demandes de contact</li>
                            <li><strong>Sous-traitants techniques :</strong> OVH (hébergement), prestataires de maintenance du site</li>
                            <li><strong>Plateformes de vente :</strong> Leboncoin et Facebook Marketplace pour la revente d'objets</li>
                            <li><strong>Partenaires logistiques :</strong> transporteurs pour la livraison d'objets vendus</li>
                            <li><strong>Organismes officiels :</strong> administrations fiscales, comptables (dans le cadre légal)</li>
                            <li><strong>Autorités compétentes :</strong> si requis par la loi</li>
                        </ul>
                        <p>Nous nous assurons que ces tiers respectent la confidentialité de vos données par des clauses contractuelles appropriées et des vérifications de conformité RGPD.</p>
                    </section>

                    <section className="legal-section">
                        <h2>9. Sécurité des données</h2>
                        <p>Nous mettons en place des mesures techniques et organisationnelles appropriées pour protéger vos données contre :</p>
                        <ul>
                            <li>L'accès non autorisé</li>
                            <li>La divulgation accidentelle ou illicite</li>
                            <li>La modification non autorisée</li>
                            <li>La destruction ou la perte</li>
                        </ul>
                        <p>Ces mesures incluent :</p>
                        <ul>
                            <li>Chiffrement SSL/TLS pour la transmission des données du formulaire</li>
                            <li>Hébergement sécurisé chez OVH (France)</li>
                            <li>Accès restreint aux données personnelles</li>
                            <li>Formation du personnel à la protection des données</li>
                            <li>Sauvegarde régulière et sécurisée des données</li>
                        </ul>
                    </section>

                    <section className="legal-section">
                        <h2>10. Vos droits</h2>
                        <p>Conformément au RGPD, vous disposez des droits suivants :</p>
                        <ul>
                            <li><strong>Droit d'accès :</strong> obtenir des informations sur le traitement de vos données</li>
                            <li><strong>Droit de rectification :</strong> corriger des données inexactes ou incomplètes</li>
                            <li><strong>Droit à l'effacement :</strong> demander la suppression de vos données</li>
                            <li><strong>Droit à la limitation :</strong> limiter le traitement de vos données dans certains cas</li>
                            <li><strong>Droit à la portabilité :</strong> récupérer vos données dans un format structuré</li>
                            <li><strong>Droit d'opposition :</strong> vous opposer au traitement pour des raisons légitimes</li>
                            <li><strong>Droit de retrait du consentement :</strong> pour les traitements basés sur le consentement</li>
                        </ul>
                        <p>Pour exercer ces droits, contactez-nous :</p>
                        <ul>
                            <li><strong>Par téléphone :</strong> 07 67 56 72 54</li>
                            <li><strong>Par email :</strong> <a href="mailto:ccdebarras14@gmail.com">ccdebarras14@gmail.com</a></li>
                            <li><strong>En précisant :</strong> votre demande, vos nom et prénom, et une copie de votre pièce d'identité</li>
                        </ul>
                        <p>Nous vous répondrons dans un délai maximum d'un mois.</p>
                    </section>

                    <section className="legal-section">
                        <h2>11. Cookies et technologies similaires</h2>
                        <p>Notre site utilise des cookies pour :</p>
                        <ul>
                            <li><strong>Cookies essentiels :</strong> assurer le bon fonctionnement du site et du formulaire de contact</li>
                            <li><strong>Cookies analytiques :</strong> analyser le trafic et améliorer l'expérience utilisateur</li>
                            <li><strong>Cookies fonctionnels :</strong> mémoriser vos préférences de navigation</li>
                        </ul>
                        <p>Vous pouvez paramétrer votre navigateur pour refuser certains cookies, mais cela peut affecter le fonctionnement du site et du formulaire de contact.</p>
                        <p>Nous n'utilisons pas de cookies publicitaires ou de suivi à des fins commerciales externes.</p>
                    </section>

                    <section className="legal-section">
                        <h2>12. Transferts de données hors UE</h2>
                        <p>Vos données personnelles sont traitées et stockées principalement au sein de l'Union Européenne :</p>
                        <ul>
                            <li><strong>Hébergement principal :</strong> OVH en France</li>
                            <li><strong>Service EmailJS :</strong> conforme RGPD avec garanties appropriées</li>
                        </ul>
                        <p>En cas de transfert exceptionnel hors UE, nous nous assurons de la mise en place de garanties appropriées conformément au RGPD (clauses contractuelles types, décisions d'adéquation).</p>
                    </section>

                    <section className="legal-section">
                        <h2>13. Réclamations</h2>
                        <p>Si vous estimez que vos droits ne sont pas respectés, vous pouvez :</p>
                        <ul>
                            <li>Nous contacter directement pour résoudre le problème</li>
                            <li>Introduire une réclamation auprès de la CNIL</li>
                        </ul>
                        <p><strong>Commission Nationale de l'Informatique et des Libertés (CNIL) :</strong></p>
                        <p>Adresse : 3 Place de Fontenoy - TSA 80715 - 75334 PARIS CEDEX 07</p>
                        <p>Téléphone : 01 53 73 22 22</p>
                        <p>Site web : <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">www.cnil.fr</a></p>
                    </section>

                    <section className="legal-section">
                        <h2>14. Modifications de cette politique</h2>
                        <p>Cette politique de confidentialité peut être modifiée pour s'adapter aux évolutions légales, techniques ou de nos services. La version en vigueur est celle publiée sur notre site web.</p>
                        <p>En cas de modification substantielle, nous vous en informerons par les moyens appropriés (email, notification sur le site).</p>
                        <p><strong>Dernière mise à jour :</strong> 15/08/2025</p>
                    </section>

                    <section className="legal-section">
                        <h2>15. Contact pour questions relatives à cette politique</h2>
                        <p>Pour toute question concernant cette politique de confidentialité ou le traitement de vos données personnelles :</p>
                        <ul>
                            <li><strong>Email :</strong> <a href="mailto:ccdebarras14@gmail.com">ccdebarras14@gmail.com</a></li>
                            <li><strong>Téléphone :</strong> 07 67 56 72 54</li>
                            <li><strong>Objet :</strong> "Question données personnelles - RGPD"</li>
                        </ul>
                    </section>

                    <section className="legal-section">
                        <p><strong>Date de dernière mise à jour :</strong> 15/08/2025</p>
                    </section>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default PrivacyPolicy;